export default "__VITE_ASSET__c15fb3c3__"